var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightsOn75 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(31.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(27.061 1.399) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.137,
    height: 2.273,
    transform: "translate(23.895 4.937) rotate(-60.113)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(23 8.382)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(23.829 12.973) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(26.968 16.558) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(31.382 15.734)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(34.834 15.206) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(37.601 12.896) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(38.734 8.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(37.646 5.189) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(34.92 2.847) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.436,9.027a4.554,4.554,0,1,0,4.555-4.555V9.027Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightsOn75);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lights-on-75.e3cea8be31958bfda3a23b8409246d8e.svg";